import { ExtendableError } from 'ts-error';

export class AuthenticationException extends ExtendableError { }
